export const ANIME_SEARCH_REQUEST = "ANIME_SEARCH_REQUEST";
export const ANIME_SEARCH_SUCCESS = "ANIME_SEARCH_SUCCESS";
export const ANIME_SEARCH_FAIL = "ANIME_SEARCH_FAIL";
export const ANIME_SEARCH_CLEAR = "ANIME_SEARCH_CLEAR";

export const ANIME_STREAM_EXTERNAL_REQUEST = "ANIME_STREAM_EXTERNAL_REQUEST";
export const ANIME_STREAM_EXTERNAL_SUCCESS = "ANIME_STREAM_EXTERNAL_SUCCESS";
export const ANIME_STREAM_EXTERNAL_FAIL = "ANIME_STREAM_EXTERNAL_FAIL";
export const ANIME_STREAM_EXTERNAL_CLEAR = "ANIME_STREAM_EXTERNAL_CLEAR";

export const ANIME_STREAM_URL_REQUEST = "ANIME_STREAM_URL_REQUEST";
export const ANIME_STREAM_URL_SUCCESS = "ANIME_STREAM_URL_SUCCESS";
export const ANIME_STREAM_URL_FAIL = "ANIME_STREAM_URL_FAIL";
export const ANIME_STREAM_URL_CLEAR = "ANIME_STREAM_URL_CLEAR";

export const ANIME_STREAM_DETAILS_REQUEST = "ANIME_STREAM_DETAILS_REQUEST";
export const ANIME_STREAM_DETAILS_SUCCESS = "ANIME_STREAM_DETAILS_SUCCESS";
export const ANIME_STREAM_DETAILS_FAIL = "ANIME_STREAM_DETAILS_FAIL";
export const ANIME_STREAM_DETAILS_CLEAR = "ANIME_STREAM_DETAILS_CLEAR";

export const ANIME_DETAILS_REQUEST = "ANIME_DETAILS_REQUEST";
export const ANIME_DETAILS_SUCCESS = "ANIME_DETAILS_SUCCESS";
export const ANIME_DETAILS_FAIL = "ANIME_DETAILS_FAIL";

export const ANIME_EPISODES_ADD_REQUEST = "ANIME_EPISODES_ADD_REQUEST";
export const ANIME_EPISODES_ADD_SUCCESS = "ANIME_EPISODES_ADD_SUCCESS";
export const ANIME_EPISODES_ADD_FAIL = "ANIME_EPISODES_ADD_FAIL";

export const ANIME_CURRENT_EP_REQUEST = "ANIME_CURRENT_EP_REQUEST";
export const ANIME_CURRENT_EP_SUCCESS = "ANIME_CURRENT_EP_SUCCESS";
export const ANIME_CURRENT_EP_FAIL = "ANIME_CURRENT_EP_FAIL";

export const DOWNLOAD_LIBRARY_REQUEST = "DOWNLOAD_LIBRARY_REQUEST";
export const DOWNLOAD_LIBRARY_SUCCESS = "DOWNLOAD_LIBRARY_SUCCESS";
export const DOWNLOAD_LIBRARY_FAIL = "DOWNLOAD_LIBRARY_FAIL";

export const ANIME_EXPLORE_DETAILS_REQUEST = "ANIME_EXPLORE_DETAILS_REQUEST";
export const ANIME_EXPLORE_DETAILS_SUCCESS = "ANIME_EXPLORE_DETAILS_SUCCESS";
export const ANIME_EXPLORE_DETAILS_FAIL = "ANIME_EXPLORE_DETAILS_FAIL";

export const ANIME_RECOMMENDATION_REQUEST = "ANIME_RECOMMENDATION_REQUEST";
export const ANIME_RECOMMENDATION_SUCCESS = "ANIME_RECOMMENDATION_SUCCESS";
export const ANIME_RECOMMENDATION_FAIL = "ANIME_RECOMMENDATION_FAIL";
